import { StyleSheet, View } from 'react-native';

import { IconStarRateFill, Skeleton, Text, tokens } from '@fhs/ui';

interface EstimatedPointsEarnedProps {
  totalPointsEarned?: number;
  isLoading?: boolean;
}

export function EstimatedPointsEarned({ totalPointsEarned, isLoading }: EstimatedPointsEarnedProps) {
  const formattedPoints = totalPointsEarned?.toLocaleString();

  return (
    <View
      style={styles.container}
      accessibilityRole="text"
      accessibilityLabel={
        isLoading ? 'Loading estimated points' : `Estimated points earned, ${formattedPoints} points`
      }
    >
      <Text.Paragraph size="sm" weight="semibold">
        Estimated Points Earned
      </Text.Paragraph>
      {isLoading ? (
        <Skeleton style={styles.skeleton} />
      ) : (
        <View style={styles.pointsContainer}>
          <IconStarRateFill size={16} color={tokens.colors.$houseYellow} />
          <Text.Paragraph size="sm" weight="semibold">
            {formattedPoints}
          </Text.Paragraph>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pointsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  skeleton: {
    height: 16,
    width: 48,
    borderRadius: 4,
  },
});
